import React, { useState, useEffect } from "react";
import { Card, Button } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";
import "./organisation.css";
import { useSelector } from "react-redux";
import axios from "axios";

const Organisation = () => {
  const [activeSection, setActiveSection] = useState("details");
  const [organisationDetails, setOrganisationDetails] = useState(null);
  const [inspectConfig, setInspectConfig] = useState(null)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const userInfo = useSelector((state) => state.appStore?.user);
  const userEmail = useSelector((state) => state.appStore?.user?.email || state.appStore?.user?.org_email);
  console.log("15", userInfo);
  const org_logo = `${process.env.PUBLIC_URL}/org_admin/org_logo.png`;

  console.log("userEmail", userEmail);
  const fetchLogoFromAzure = async (organizationId, organizationName) => {
    try {
      // File details
      const fileName = `${organizationId}-${organizationName}.jpeg`;

      // Base URL
      const baseUrl = 'https://caisdatahouse.blob.core.windows.net/insurance-inspection/organization-logos';

      // ✅ Append SAS Token for access
      const sasToken = 'sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D';

      // ✅ Full URL with SAS Token
      const logoUrl = `${baseUrl}/${fileName}?${sasToken}`;

      // Fetch the image to verify it exists
      const fetchResponse = await axios.get(logoUrl, { responseType: 'blob' });

      if (fetchResponse.status === 200) {
        console.log('Logo fetched successfully');

        // Convert Blob to Object URL for rendering
        const fetchedLogo = URL.createObjectURL(fetchResponse.data);


        return { logoUrl, fetchedLogo };
      } else {
        throw new Error('Failed to fetch uploaded logo');
      }
    } catch (error) {
      console.error('Error fetching logo:', error);
      return null;
    }
  };

  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    const fetchLogo = async () => {
      if (userInfo) {
        try {
          const fetchedData = await fetchLogoFromAzure(userInfo.org_id, userInfo.org_name);
          console.log("Fetched Logo Data:", fetchedData);
          if (fetchedData) {
            setLogoUrl(fetchedData.fetchedLogo);
          }
        } catch (error) {
          console.error("Error fetching logo:", error);
        }
      }
    };

    fetchLogo();
  }, [userInfo]); // Runs when userInfo changes


  useEffect(() => {
    if (userEmail) {

      fetchOrganisationDetails(userEmail);
    }
  }, [userEmail]);

  const fetchOrganisationDetails = async (email) => {
    setLoading(true);
    setError(null);
    try {
      const user = localStorage.getItem('insuranceUser');
      const user_info = JSON.parse(user);
      const token = user_info.token;
      console.log("token", token);

      const response = await axios.get(`/auth/organisation?email=${email}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const organisation = response.data.result[0];

      if (organisation.inspection_config) {
        try {
          const inspectionConfig = JSON.parse(organisation.inspection_config);
          console.log(inspectionConfig.selectedCount); // Output: 12
          setInspectConfig(inspectionConfig)
        } catch (error) {
          console.error("Error parsing inspection_config:", error);
        }
      }

      // console.log("97", organisation.inspection_config, organisation.org_name);
      setOrganisationDetails(organisation);
    } catch (err) {
      console.error("Error fetching organisation details:", err);
      setError("Failed to load organisation details.");
    } finally {
      setLoading(false);
    }
  };

  const handleNavigation = (sectionId) => {
    setActiveSection(sectionId);
  };

  // const apiDetails = {
  //   "360 View": 12,
  //   "Chassis & RC": "3",
  //   OptIn: userInfo?.api_opt ? "yes" : "no",
  //   Category: userInfo?.category || "Post",
  //   // Description: "Name, name",
  // };
  const rawInspectionConfig = userInfo?.inspection_config;
  const inspection_config = rawInspectionConfig ? JSON.parse(rawInspectionConfig) : null;
  // const inspection_config=userInfo?.inspection_config
  console.log("130", inspection_config);
  console.log("130", inspection_config?.selectedItems);

  // const apiDetails = {
  //   "360 View": 8 + (inspection_config?.selectedItems?.length || 0),  // 8 + length of selectedItems array
  //   "Chassis & RC": "2",
  //   OptIn: userInfo?.api_opt ? "yes" : "no",
  //   Category: userInfo?.category || "Post",
  //   // Description: "Name, name",
  // };
  const apiDetails = {
    "360 View": (inspection_config?.selectedItems?.includes("Tyres") ? 20 : 16),  // 8 + length of selectedItems array
    ...(inspection_config?.selectedItems?.includes("Chassis") ? { "Chassis": "1" } : { "Chassis": "0" }),
    OptIn: userInfo?.api_opt ? "yes" : "no",
    Category: userInfo?.category || "Post",
  };
  // const apiDetails = {
  //   "360 View": (inspection_config?.selectedItems?.length || 0),  // 8 + length of selectedItems array
  //   ...(inspection_config?.selectedItems?.includes("Chassis") ? { "Chassis": "1" }: { "Chassis": "0" }),
  //   OptIn: userInfo?.api_opt ? "yes" : "no",
  //   Category: userInfo?.category || "Post",
  // };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", backgroundColor: "#ffffff" }}>
      {/* Header */}
      {/* <div className="header">
        <div className="header-add">
          <div className="header-icon">
            <h3 className="header-title">{organisationDetails ? organisationDetails.org_name : "Organisation name"}</h3>
          </div>
        </div>
        <div className="header-actions">
          <Button className="credits-button-org">
            <ShoppingCartOutlined /> 1200 USD
          </Button>
        </div>
      </div> */}
      <div className="header">
        <div className="header-add">
          <div className="header-icon">
            <img src={org_logo} alt="Organisation Logo" className="org-logo" />
            <h3 className="header-title">
              {organisationDetails ? organisationDetails.org_name : "Organisation name"}
            </h3>
          </div>
        </div>
        <div className="header-actions">
          <Button className="credits-button-org">
            <ShoppingCartOutlined /> 1200 USD
          </Button>
        </div>
      </div>

      {/* Sidebar and Content */}
      <div style={{ display: "flex", flex: 1 }}>
        {/* Sidebar */}
        {/* <div className="sidebar-org">
          <ul className="sidebar-menu-org">
            <li
              className={activeSection === "details" ? "active" : ""}
              onClick={() => handleNavigation("details")}
            >
              Details
            </li>
            <li
              className={activeSection === "inspect" ? "active" : ""}
              onClick={() => handleNavigation("inspect")}
            >
              Inspect
            </li>
            <li
              className={activeSection === "api" ? "active" : ""}
              onClick={() => handleNavigation("api")}
            >
              API
            </li>
            <li
              className={activeSection === "billing" ? "active" : ""}
              onClick={() => handleNavigation("billing")}
            >
              Billing
            </li>
          </ul>
        </div> */}

        {/* Main Content */}
        <div className="content-container">
          <Card className="details-card">
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p style={{ color: "red" }}>{error}</p>
            ) : organisationDetails ? (
              <div className="organisation-details">
                <h3>Organisation details</h3>
                {/* <img src={logoUrl} alt="Logo" className="organisation-logo" /> */}
                <div className="details-grid">
                  <div>
                    <p className="label">Company Name</p>
                    <p className="value">{organisationDetails.org_name}</p>
                  </div>
                  <div>
                    <p className="label">Email</p>
                    <p className="value">{organisationDetails.org_email}</p>
                  </div>
                </div>
              </div>
            ) : (
              <p>No organisation details available.</p>
            )}

            {/* API Details Section */}
            <div className="api-details">
              <h3 className="api-title">API</h3>
              <div className="api-grid">
                <div>
                  <p className="label">360 View</p>
                  <p className="value">{apiDetails["360 View"]}</p>
                </div>
                <div>
                  <p className="label">Chassis </p>
                  <p className="value">{apiDetails["Chassis"]}</p>
                </div>
              </div>

              <div className="api-grid">
                <div>
                  <p className="label">Opt-In</p>
                  <p className="value">{apiDetails.OptIn}</p>
                </div>
                <div>
                  <p className="label">Category</p>
                  <p className="value">{apiDetails.Category}</p>
                </div>
                {/* <div>
                  <p className="label">Description</p>
                  <p className="value">{apiDetails.Description}</p>
                </div> */}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Organisation;
